import { render, staticRenderFns } from "./SuperSyndicateHeader.vue?vue&type=template&id=7220ea6f&scoped=true&"
import script from "./SuperSyndicateHeader.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicateHeader.vue?vue&type=script&lang=js&"
import style0 from "./Styles/SuperSyndicate.css?vue&type=style&index=0&id=7220ea6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220ea6f",
  null
  
)

export default component.exports